export default {
  spendField: 'spend_ltd',
  interpolateMonths: true,
  trendMetrics: [
    {
      metric: 100,
      field: 'adpi',
      label: 'Ad Effect Score',
      format: '.0f',
      scale: [80, 160]
    },
    {
      metric: 111,
      field: 'recall',
      label: 'Branded Recall with Spend',
      format: '.0%',
      hasSpendData: true,
      scale: [0, 0.8]
    },
    {
      metric: 121,
      field: 'consideration',
      label: 'Lift to Consideration',
      format: '.0%',
      scale: [0, 0.6]

    },
    {
      metric: 122,
      field: 'impression',
      label: 'Lift to Impression',
      format: '.0%',
      scale: [0, 0.6]
    },
    {
      metric: 123,
      field: 'actions',
      label: 'Net Actions',
      format: '.0%',
      scale: [0, 0.6]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/scorecard/Trendchart/index.js